import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import { courseRef, database } from '../firebase'
import $ from 'jquery';
export default class MyAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username:"",
      password:"", 
    }
    this.handleChange = this.handleChange.bind(this);
}
handleChange = (event) => {
  const { value, name } = event.target;
  this.setState({
      [name]: value,
  });
};

async  loginSubmit(){
    if(this.state.username ==='' ){
      alert('Please enter your user name');
      $("#username").focus();
    }
    else if(this.state.password===''){
      alert('Please enter  password')
      $("#password").focus();
    }
    else{
    
        const ref = 'SecUser/'
        const userRef = database.ref(ref)
        const valueRef =await userRef.orderByChild('emailId').equalTo(this.state.username)
       
        const snapshot = await valueRef.once('value')  
        snapshot.forEach(c => { var val = c.val();
          console.log("loginval........",val)    
          if(val.password===this.state.password){
            localStorage.setItem("userId",val.userId)
            localStorage.setItem("guidanceId", val.guidanceId);
            window.localStorage.setItem('userName',val.fullName);
            window.localStorage.setItem('Role',val.role);
            window.localStorage.setItem('LoginFlag','true');            
            alert("Login successful",val.role) 
            console.log("role...",val.role)
            if(val.role==='ADMIN'){
              window.location.href = "/dashboard"
            }
            if(val.role==='User'){
              window.location.href = "/user-dashboard"
            }
          }
          else{
            alert('Login failed ! incorrect password')
          }
        }) 
      } 

  }
    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content myaccount-wrapper m-0">    
            <div className="container">
                <div className='col-md-7' style={{margin:"auto"}}>
                  <form className='form-main-wrapper'>
                    <div className='subhead'>SIGN IN</div>
                    <div className=' myaccount-form'>
                      <div className="form-group">
                        <label for="exampleFormControlInput1">Username or email address <span className='text-danger'>*</span> </label>
                        <input type="text" name="username" id="username" className="form-control" onChange={this.handleChange}/>
                      </div>
                      <div className="form-group">
                        <label for="exampleFormControlInput1">Password <span className='text-danger'>*</span></label>
                        <input type="password" name="password" id="password" className="form-control" placeholder="Password" onChange={this.handleChange}/>
                      </div>
                      <div className="form-group row">
                        <div className="form-check col-lg-7">
                          <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                          <label className="form-check-label" for="exampleCheck1"><strong>Remember me</strong></label>
                          {/* <div>
                            <a href='/lost-password' className='link-color' style={{fontSize:"12px"}}>Forgot Password</a>
                          </div> */}
                        </div>
                        <div className="form-check col-lg-5" style={{textAlign:"right"}}>
                        <button type="button" className="btn btn-gray" onClick={()=>this.loginSubmit()}>Log in.</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
            
        </div>
        <Footer></Footer>
        
      </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/ivano/my-account.jsx